namespace Gamification.Gamification {
    export interface ProdottiBadgeForm {
        IdentifierBadge: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
    }

    export class ProdottiBadgeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiBadge';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiBadgeForm.init)  {
                ProdottiBadgeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(ProdottiBadgeForm, [
                    'IdentifierBadge', w0,
                    'Nome', w0,
                    'Descrizione', w1
                ]);
            }
        }
    }
}
